module.exports = __webpack_public_path__ + "site/img/139.04a23a2b.jpg";